import React from "react";
import { motion } from "framer-motion";
import {
  FaUserCheck,
  FaFileAlt,
  FaUserTie,
  FaUserPlus,
  FaClipboardCheck,
  FaUserClock,
  FaBan,
  FaUserGraduate,
  FaUserTimes,
  FaCheckCircle,
  FaPauseCircle,
} from "react-icons/fa";

const steps = [
  { id: "applied", label: "Applied", icon: <FaFileAlt /> },
  { id: "shortlisted", label: "Shortlisted", icon: <FaClipboardCheck /> },
  { id: "screening", label: "Screening", icon: <FaUserClock /> },
  { id: "interviewing", label: "Interviewing", icon: <FaUserTie /> },
  { id: "selected", label: "Selected", icon: <FaUserCheck /> },
  { id: "offered", label: "Offered", icon: <FaUserPlus /> },
  { id: "not-joined", label: "Not Joined", icon: <FaUserTimes /> },
  { id: "joined", label: "Joined", icon: <FaUserGraduate /> },
  { id: "training", label: "Training", icon: <FaUserClock /> },
  { id: "onboarding", label: "Onboarding", icon: <FaClipboardCheck /> },
  { id: "hired", label: "Hired", icon: <FaCheckCircle /> },
  { id: "rejected", label: "Rejected", icon: <FaBan /> },
  { id: "on-hold", label: "On-Hold", icon: <FaPauseCircle /> },
  { id: "abscond", label: "Abscond", icon: <FaUserTimes /> },
];

const statusColors = {
  applied: "bg-gray-300 text-gray-800",
  shortlisted: "bg-blue-300 text-blue-800",
  screening: "bg-yellow-300 text-yellow-800",
  interviewing: "bg-purple-300 text-purple-800",
  selected: "bg-green-300 text-green-800",
  offered: "bg-teal-300 text-teal-800",
  "not-joined": "bg-red-300 text-red-800",
  joined: "bg-indigo-300 text-indigo-800",
  training: "bg-pink-300 text-pink-800",
  onboarding: "bg-orange-300 text-orange-800",
  hired: "bg-green-500 text-white",
  rejected: "bg-red-500 text-white",
  "on-hold": "bg-gray-400 text-white",
  abscond: "bg-black text-white",
};

export default function ApplicationFlow() {
  return (
    <div className="w-full min-h-screen flex flex-col items-center justify-center bg-gradient-to-r from-blue-50 to-indigo-100 p-6">
      <h1 className="text-3xl font-bold mb-10 text-indigo-800">
        Candidate Application Lifecycle
      </h1>
      <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
        {steps.map((step, index) => (
          <motion.div
            key={step.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.15 }}
            className={`flex flex-col items-center justify-center p-6 rounded-2xl shadow-lg ${statusColors[step.id]} hover:scale-105 transition-transform duration-300`}
          >
            <div className="text-4xl mb-3">{step.icon}</div>
            <h2 className="text-lg font-semibold">{step.label}</h2>
          </motion.div>
        ))}
      </div>

      {/* Notes Section */}
      <div className="mt-12 max-w-3xl bg-white rounded-2xl shadow-md p-6 text-gray-700">
        <h2 className="text-xl font-bold mb-4 text-indigo-700">How it Works?</h2>
        <ul className="list-disc ml-6 space-y-2">
          <li><strong>Applied → Shortlisted:</strong> Resume is reviewed and shortlisted.</li>
          <li><strong>Screening → Interviewing:</strong> HR/technical screening followed by interviews.</li>
          <li><strong>Selected → Offered:</strong> Candidate clears interviews and receives an offer.</li>
          <li><strong>Offered → Joined:</strong> Candidate accepts the offer and joins the company.</li>
          <li><strong>Joined → Training:</strong> Candidate undergoes training (probation/skills).</li>
          <li><strong>Training → Onboarding:</strong> After successful training, onboarding and documentation are completed.</li>
          <li><strong>Onboarding → Hired:</strong> Candidate becomes a confirmed employee.</li>
          <li className="text-red-600"><strong>Exit Cases:</strong> Rejected, Not Joined, Abscond, On-Hold (paused).</li>
        </ul>
      </div>
    </div>
  );
}